import { Plus } from '@hungryroot/icons';
import { IconButton } from '@hungryroot/ramen';
import styles from './PlusButton.module.css';

interface PlusButtonProps {
  onClick: () => void;
  className?: string;
}

export function PlusButton(props: PlusButtonProps) {
  const { onClick, className } = props;
  return (
    <IconButton
      ariaLabel="Plus"
      testid="rdp-add-button"
      className={`${styles.icon} ${className}`}
      size="small"
      style="default"
      prominence="secondary"
      onClick={onClick}
      icon={<Plus />}
    ></IconButton>
  );
}
